<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Client Request Close
    </div>
    <div class="card-body">
        <div class="container mt-1">
            <div class="card shadow-sm Label">
                <!-- <div class="card-header py-2 small">
                    Complaint Details
                </div> -->

                <div class="card-body py-2 small">
                    <div class="row g-2">
                        <div class="col-md-4">
                            <span class="fw-semibold">Name : </span>
                            <span>{{ InputData.Name }}</span>
                        </div>
                        <div class="col-md-4">
                            <span class="fw-semibold">Contact No : </span>
                            <span>{{ InputData.ContactNo }}</span>
                        </div>
                        <div class="col-md-4">
                            <span class="fw-semibold">Email : </span>
                            <span>{{ InputData.Email }}</span>
                        </div>
                        <div class="col-md-12">
                            <span class="fw-semibold">Site Details: </span>
                            <span class="ms-2">{{ InputData.BranchName }} - {{ InputData.ClientLocation }} - {{
                                InputData.SiteName }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row mx-1 mt-2">
            <div class="col-md-5">
                <label class="Label mb-1">Complaint Type <span class="text-danger">*</span></label>
                <div class="input-group">
                    <ng-select class="w-100" [items]="ComplaintTypes" bindLabel="ComplaintType"
                        bindValue="ESS_ClientPortalComplaintTypeID" [(ngModel)]="ComplaintType"
                        placeholder="Complaint Type" name="Complaint" #Complaint="ngModel" required>
                    </ng-select>
                    <div class="invalid-feedback fs-7">
                        Please select complaint!
                    </div>
                </div>
            </div>

            <div class="col-md-5 px-1">
                <label class="form-font-label" style="font-size: 14px;">File Upload </label>
                <div class="file-input-container">
                    <input class="form-control form-control-sm" id="formFileSm" type="file" *ngIf="!Attachment"
                        accept=".pdf,image/*" />
                    <span *ngIf="Attachment" class="file-name">{{ Attachment
                        }}</span>
                    <span *ngIf="Attachment "> <button class="btn btn-sm" name="view" type="button" style="color: blue;"
                            (click)="viewFile()"><i class="bi bi-eye"></i></button></span>
                    <button class="btn btn-sm" name="delete" type="button" *ngIf="Attachment" (click)="removeFile()">
                        <i class="bi bi-trash text-danger"></i>
                    </button>
                </div>
            </div>

            <!-- <div class="col-md-8">
                <label class="Label mb-1">User <span class="text-danger">*</span></label>
                <ng-select [items]="UserMaster" bindLabel="UserCode" bindValue="UserMasterId" (change)="onUserChange()"
                    placeholder="User" [(ngModel)]="UserId" name="userMaster">
                </ng-select>
                <div class="invalid-feedback">
                    Please select User
                </div>
            </div> -->

            <div class="col-md-12">
                <label class="Label mb-1">Remark <span class="text-danger">*</span></label>
                <textarea type="textarea" rows="3" class="form-control" [(ngModel)]="Remark" name="description"
                    #description="ngModel" placeholder="Enter description"></textarea>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-outline-primary" name="cancel" (click)="Close(false)">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button class="btn btn-sm btn-primary" name="save" (click)="save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save and Close':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>